<template>
  <main-layout>
    <section class="people-center-activity">
      <div class="container">
        <div class="left">
          <h4  v-if="userInfo.nickname">{{$t('global.x的直播',{name:userInfo.nickname})}}</h4>
          <span>
            {{$t('live.参与的直播')}}
            <small>{{liveListLength}}</small>
          </span>
          <div class="activity-list">
            <ul>
              <li v-for="item in liveList" :key="item.id">
                <live-card @refresh="refresh" :item="item" :language="language" />
              </li>
            </ul>
            <Loading v-if="loading" />
            <Reload v-if="loadError" @callback="loadMore" />
            <no-more v-if="!hasNextPage && liveList.length" />
          </div>
        </div>

        <div class="right">
          <div class="user-fllow">
            <div :class="{'userType2':userInfo.userType === 2 && userInfo.isCertification === 1}">
              <img :src="userInfo.avatar | imageUrl('',160,160)" alt />
              <h4>{{userInfo.nickname}}</h4>
            </div>
            <div class="location">
              <img src="/static/v2/location_icon.png" v-if="userInfo.area" />
              <span class="area" v-if="userInfo.area">{{userInfo.area}}</span>
              <router-link target="_blank" :to="'/peopleCenter/'+userId">{{$t('global.个人主页')}}</router-link>
            </div>
            <button
              class="member-focus"
              v-bind:class="{following: userInfo.isFollow,'add-follow':!userInfo.isFollow}"
              @click.prevent.stop="follow(userInfo)"
            >{{!userInfo.isFollow?$t('global.关注'):$t('global.已关注')}}</button>
          </div>
        </div>
      </div>
    </section>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import liveCard from "@/components/v2/peopleCenter/LiveCard";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import NoMore from "@/components/v2/NoMore";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";

export default {
  metaInfo() {
    return {
      title: this.$t("global.发起的活动") + " | MANA"
    };
  },
  components: {
    MainLayout,
    liveCard,
    Reload,
    Loading,
    NoMore
  },
  data() {
    return {
      userId: null,
      pageIndex: 1,
      pageSize: 9,
      liveListLength: 0,
      liveList: [],
      userInfo: {},
      loadError: false,
      loading: false,
      hasNextPage: false
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    init() {
      this.userId = this.$route.params.userId;
      this.getLiveList();
      this.getUserInfo();
    },
    getUserInfo() {
      const url = `/api/mobile/u/getInfo`;
      const params = {
        userId: this.userId
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.userInfo = res.data;
        }
      });
    },
    getLiveList() {
      this.loading = true;
      const url = `/api/bytedance/user/all/` + this.userId;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: 20
      };
      this.$http.get(url, { params }).then(res => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.liveList = [];
          }
          this.hasNextPage = res.data.hasNextPage;
          this.liveListLength = res.data.totalRecord;
          this.liveList = [...this.liveList, ...res.data.list];
        } else {
          this.loadError = true;
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
        }
      });
    },
    refresh() {
        this.getLiveList();
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 250) {
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          this.getLiveList();
        }
      }
    },
    follow(item) {
      const url = `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
        this.userId
      }`;
      this.$http.post(url).then(res => {
        if (res.code === "OK") {
          item.isFollow = !item.isFollow;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.people-center-activity {
  background: #fff;
  min-height: calc(100vh - 228px);

  .container {
    width: 1110px;
    display: flex;
    flex-direction: row;
    padding-top: 90px;
    margin: 0 auto;

    .left {
      width: 730px;
      margin-right: 95px;

      h4 {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 33px;
        color: #0A0A0A;
      }

      &>span {
        display: inline-block;
        margin-top: 30px;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #0A0A0A;

        small {
          font-size: 14px;
          font-family: NunitoSans-SemiBold, NunitoSans;
          font-weight: 600;
          color: #999;
        }
      }

      .activity-list {
        margin-top: 20px;
        border-top: 1px solid #E0E0E0;
        padding-bottom: 120px;

        ul {
          padding: 30px 0 50px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          li {
            width: 350px;
            margin-right: 30px;

            &:nth-child(2n) {
              margin-right: 0;
            }
          }
        }
      }
    }

    .right {
      width: 285px;

      .user-fllow {
        width: 285px;
        height: 270px;
        border: 1px solid #EBEBEB;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 30px;
        box-sizing: border-box;

        div {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 100%;

          &.userType2::before {
            content: '';
            right: calc(50% - 36px);
            top: 60px;
            position: absolute;
            width: 16px;
            height: 16px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 16px;
          }

          img {
            width: 80px;
            height: 80px;
            border-radius: 40px;
            border: 1px solid #f5f5f5;
          }

          h4 {
            color: #333333;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            padding: 15px 0 5px;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .location {
          padding: 11px 0 31px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          img {
            width: 10px;
            height: 13px;
            margin-right: 3px;
          }

          .area {
            font-size: 14px;
            color: #999;
            padding-right: 15px;
          }

          a {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2026CC;
          }
        }

        .member-focus {
          width: 90px;
          height: 30px;
          padding: 5px 0;
          background: #2026CC;
          color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;

          &.add-follow::before {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url('/static/v2/channel_follow_btn_plus.png');
            background-size: 12px;
            margin-right: 3px;
            vertical-align: middle;
            margin-top: -2px;
          }

          &.following {
            background: #fff;
            border: 1px solid #b8b8b8;
            color: #b8b8b8;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/peopleCenter/PeopleCenterLive.vue